module.exports = __webpack_public_path__ + "static/media/ticket-banner.6f8fce57.png";